import type { ReportColumn, StreamedSourceConfig } from '../types';

/**
 * Columns that only mean something after the missing-data run. Ticking any of these (or their B
 * twins, which follow automatically) asks the user to press Start before Export is enabled.
 */
export const CASE_ENRICHED_KEYS = new Set([
  'firstName', 'surname', 'email', 'phone', 'gender', 'dateOfBirth', 'missingFields', 'filledFrom',
]);

/** Person B duplicates. Same order as the Person A columns; no checkbox of their own. */
const twinColumns: ReportColumn[] = [
  { key: 'firstNameB', label: 'First Name (B)', category: 'Person' },
  { key: 'surnameB', label: 'Surname (B)', category: 'Person' },
  { key: 'emailB', label: 'Email (B)', category: 'Person' },
  { key: 'phoneB', label: 'Phone (B)', category: 'Person' },
  { key: 'genderB', label: 'Gender (B)', category: 'Person' },
  { key: 'dateOfBirthB', label: 'Date of Birth (B)', category: 'Person', type: 'date' },
];

export const caseSource: StreamedSourceConfig = {
  mode: 'streamed',
  label: 'Case',
  plural: 'Cases',
  primaryKey: 'caseID',
  columns: [
    { key: 'caseID', label: 'ID', category: 'Case' },
    { key: 'name', label: 'Case Name', category: 'Case', defaultVisible: true },
    { key: 'openedDisplay', label: 'Date Opened', category: 'Case', defaultVisible: true },
    { key: 'statusName', label: 'Status', category: 'Case', defaultVisible: true },
    { key: 'needName', label: 'Counselling Need', category: 'Case', defaultVisible: true },
    { key: 'locationName', label: 'Location', category: 'Church', defaultVisible: true },
    { key: 'leaderName', label: 'Leader', category: 'Case', defaultVisible: true },
    { key: 'counseleeNames', label: 'Counselees', category: 'Case' },
    // The people needing care (main counselee = Person A; a second counselee = the B twins).
    { key: 'firstName', label: 'First Name', category: 'Person', twinKey: 'firstNameB' },
    { key: 'surname', label: 'Surname', category: 'Person', twinKey: 'surnameB' },
    { key: 'email', label: 'Email', category: 'Person', twinKey: 'emailB' },
    { key: 'phone', label: 'Phone', category: 'Person', twinKey: 'phoneB' },
    { key: 'gender', label: 'Gender', category: 'Person', twinKey: 'genderB' },
    { key: 'dateOfBirth', label: 'Date of Birth', category: 'Person', type: 'date', twinKey: 'dateOfBirthB' },
    { key: 'sessionCount', label: 'Sessions', category: 'Case', type: 'number' },
    { key: 'zoneName', label: 'Zone', category: 'Church' },
    { key: 'areaName', label: 'Area', category: 'Church' },
    { key: 'activityStatus', label: 'Activity', category: 'Case' },
    { key: 'daysSinceLastActivity', label: 'Days Since Activity', category: 'Case', type: 'number' },
    { key: 'nextSessionDisplay', label: 'Next Session', category: 'Case' },
    { key: 'mainPersonAffiliation', label: 'Affiliation', category: 'Person' },
    { key: 'missingFields', label: 'Missing fields', category: 'Data quality', trailing: true },
    { key: 'filledFrom', label: 'Filled from', category: 'Data quality', trailing: true },
  ],
  twinColumns,
  filters: [
    { key: 'status', field: 'statusID', label: 'Status', type: 'select', placeholder: 'All statuses', runtimeOptions: true },
    { key: 'need', field: 'needID', label: 'Counselling Need', type: 'select', placeholder: 'All needs', runtimeOptions: true },
    { key: 'location', field: 'locationID', label: 'Location', type: 'select', placeholder: 'All locations', runtimeOptions: true },
    { key: 'leader', field: 'userId', label: 'Leader', type: 'select', placeholder: 'All leaders', runtimeOptions: true },
  ],
};